module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("A FEW DEFINITIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following are some helpful definitions of terms used in the interurban stories that may be unfamiliar to some readers.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("car: Short for "), _c('i', [_vm._v("interurban car")]), _vm._v(". Interurban cars were essentially souped-up, sometimes lavishly appointed trolley cars. Most had powerful motors and high-speed gearing, and they were usually larger and heavier than their city cousins. Cars were numbered, like “car 360,” which is on display at the Interurban Railway Museum in Plano.")]), _vm._v(" "), _c('li', [_vm._v("motorman: A rail vehicle operator.")]), _vm._v(" "), _c('li', [_vm._v("siding: A short section of railway track connected to a main line, usually parallel to a rail station, that allowed other cars trains on the same line to pass.")]), _vm._v(" "), _c('li', [_vm._v("trolley:\n"), _c('ul', {
    staticClass: "top"
  }, [_c('li', [_vm._v("A streetcar powered electrically through a trolley, also referred to as a trolley car.")]), _vm._v(" "), _c('li', [_vm._v(" A device that carries an electric current from an overhead wire to an electrically driven vehicle.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 75
// module chunks = 0